import React, { useEffect } from "react";
import { useMediaQuery } from "@mui/material";
import FormComponent from "../components/generic/FormComponent";

const DonationPage: React.FC = () => {
	useEffect(() => {
		const script = document.createElement("script");
		script.src = "https://js.stripe.com/v3/buy-button.js";
		script.async = true;
		document.body.appendChild(script);
	}, []);

	return (
		<FormComponent>
			<h1 className="text-3xl font-extrabold mb-6 text-center sm:text-left">Support MaterialLogs.com</h1>
			<p className="text-lg mb-6 text-center sm:text-left">
				If you find MaterialLogs.com useful, consider making a donation to support development, hosting, and future improvements.
			</p>

			<div className="bg-gray-200 dark:bg-gray-900 p-6 rounded-lg shadow-md text-center">
				<h2 className="text-2xl font-semibold mb-4">Donate via Stripe</h2>
				<p className="mb-4">Securely donate using Stripe. Every contribution helps maintain and improve this tool.</p>

				{/* Stripe Buy Button Wrapper */}
				<div className="flex justify-center">
					<div dangerouslySetInnerHTML={{
						__html: `
                            <stripe-buy-button
                                buy-button-id="buy_btn_1QnNtvD1fXE3UXwdzmCKaz8G"
                                publishable-key="pk_live_51QnNCUD1fXE3UXwdOFsi9PFMJlShBZzeiLQZ8sSHK0i6dOeewSkvXuO6ku2uGCQ8RfLTPLtGANrXXoeEMaz8i69X00kVadcz47">
                            </stripe-buy-button>
                        `
					}} />
				</div>
			</div>

			<div className="mt-8 text-center">
				<h2 className="text-2xl font-semibold mb-2">Donate via Email Transfer</h2>
				<p className="text-lg text-blue-500">donation@materiallogs.com</p>
				<p className="text-sm text-gray-600 mt-2">
					Prefer sending an email transfer? You can support us directly via this email.
				</p>
			</div>
		</FormComponent>
	);
};

export default DonationPage;
